import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    name: 'root',
    path: '/'
  },
  {
    name: 'presentation',
    path: '/:presentation?'
  },
  {
    name: 'chapter',
    path: '/:presentation/:chapter?'
  },
  {
    name: 'slide',
    path: '/:presentation/:chapter/:slide?'
  },
  {
    name: 'keyframe',
    path: '/:presentation/:chapter/:slide/:keyframe?'
  }
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;